import styled from 'styled-components';

export const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${Styles.desktop} {
    flex-direction: row;
    padding: 0;
    align-items: stretch;
    /* Setting to rem as it should grow with the font-size (arabic has bigger fonts) to not
    cause overlaps */
    margin-block-start: 12rem;
  }
`;
